import { Siren } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Tile } from "./Tile";

interface LocalEmergencyTileProps {
  readonly onSelect: () => void;
}

/**
 * Practice-authorized tile for the device-local audible emergency alert.
 *
 * @since 1.2.0
 * @example
 * ```tsx
 * <LocalEmergencyTile onSelect={() => undefined} />
 * ```
 */
export function LocalEmergencyTile({ onSelect }: LocalEmergencyTileProps) {
  const { t } = useTranslation();

  return (
    <Tile
      tone="red-subtle"
      size="band"
      className="col-span-full min-h-20"
      data-testid="flow-emergency"
      name={t("self-service.start.emergency-cta")}
      desc={t("self-service.start.emergency-description")}
      icon={<Siren />}
      onClick={onSelect}
    />
  );
}
